
































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  QueryFollowMessage,
  UpdateFollowMessage,
  DeleteFollowMessage
} from "@/api/follow/followMessage";
import FollowMessageDetail from "./detail.vue";
@Component({
  components: {
    FollowMessageDetail
  }
})
export default class FollowMessage extends AbpBase {
  loading: boolean = false;
  showMessageDetail: boolean = false;
  currentFollowMessage: any = {};
  response: any = {};
  payload = {
    QueryString: "",
    Page: 1,
    PageSize: 10
  };
  columns = [
    {
      title: "短信名称",
      key: "name",
      minWidth: 120
    },
    {
      title: "短信内容",
      key: "content",
      minWidth: 200
    },
    {
      title: "操作",
      key: "",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-create", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.handleUpdate(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            on: {
              click: () => {
                this.handleDelete(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];

  handlePageChange(val: any) {
    this.payload.Page = val;
    this.getData();
  }

  handleUpdate(row: any) {
    this.currentFollowMessage = Object.assign({}, row);
    this.showMessageDetail = true;
  }

  handleDelete(id: number) {
    this.$confirm("确定要删除吗？", "提示").then(async () => {
      await DeleteFollowMessage(id);
      this.getData();
    });
  }

  handleAdd() {
    this.currentFollowMessage = {};
    this.showMessageDetail = true;
  }

  handleDetailOk() {
    this.$refs.FollowMessageDetail.submit().then(res => {
      if (res) {
        this.showMessageDetail = false;
        this.getData();
      }
    });
  }

  handleMessageModalVisibleChange(res: boolean) {
    if (!res) {
      this.$refs.FollowMessageDetail.resetForm();
    }
  }

  created(){
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await QueryFollowMessage(this.payload);
    this.response = res.data;
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followMessage/index.vue